import React, { useState } from 'react'
import ChatV2HistoryPanel from './ChatV2HistoryPanel'
import ChatV2ContainerPanel from './ChatV2ContainerPanel'
import "./AiAssistantV2.css"

function AiAssistantV2({}) {
  const [sessionId, setSessionId] = useState(null);
  const [chatHeadings, setChatHeadings] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  return (
    <div style={{backgroundColor:"#fff" ,height:"90vh",borderRadius:"0.5rem",display:"flex",justifyContent:"flex-start",flexDirection:"row"}}>
        <ChatV2HistoryPanel chatHeadings={chatHeadings} setChatHeadings={setChatHeadings} setSessionId={setSessionId} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex}/>
        <ChatV2ContainerPanel setChatHeadings={setChatHeadings} sessionId={sessionId} setSessionId={setSessionId} setSelectedIndex={setSelectedIndex}/>
    </div>
  )
}

export default AiAssistantV2